import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import AccountAPI from '@/modules/account/constants/account.api.uri.const.ts'
import { buildFilterObject } from '@/utils/filter'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { formatTableDataRealEstate } from '../helper/table'
import {markRaw} from 'vue'
import { REAL_ESTATE_CATEGORY_OPTIONS } from '@/modules/contract/constants/realestate.const'
import RegionComp from '@/modules/flashoffer/components/RegionComp.vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum FlashOfferCreateActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface FlashOfferCreateStore {
  action_type: FlashOfferCreateActionTypes,
  action_mess: string,
  uuid: string,
  detail: Object,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useFlashOfferCreateStore = defineStore('flash_offer.create', {
  state: (): FlashOfferCreateStore => ({
    action_type: FlashOfferCreateActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'province_id',
        type: 'region-level-1',
        label: 'Lọc theo tỉnh/thành',
        placeholder: 'Chọn tỉnh / thành',
        value: '',
        options: null,
      },
      {
        key: 'ward_id',
        type: 'region-level-2',
        label: 'Lọc theo phường / xã',
        placeholder: 'Chọn phường xã',
        value: '',
        options: null,
      },
      {
        key: 'keyword',
        type: 'taginput',
        label: 'Lọc theo từ khóa',
        placeholder: 'Nhập từ khóa',
        value: '',
      },
      {
        key: 'type',
        type: 'select-multiple',
        label: 'Lọc theo Loại hình',
        placeholder: 'Nhập từ khóa',
        value: '',
        options: REAL_ESTATE_CATEGORY_OPTIONS,
      },
      {
        key: 'price',
        type: 'price-range',
        label: 'Lọc theo khoản giá',
        placeholder: 'Nhập giá',
        value: '',
      },

    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Chi tiết FlashOffer',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        id: { label: 'ID', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        address: { label: 'Địa chỉ', component: markRaw(TextCell), class: '', visible: true, sort: '', config: {} },
        region: { label: 'khu vực', component: markRaw(RegionComp), class: '', visible: true, sort: '', config: {} },
        // type: { label: 'Loại hình', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        status_text: { label: 'Trạng thái', component: markRaw(TagCell), class: '', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày đăng ký', component: markRaw(DateTimeCell), class: '', visible: true, sort: 'desc', config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
    idArray: state => {
      return state.data.list.map((item: any) => item.id)
    },
    getSelectedIds: state => {
      return state.selectedIds
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Chi tiết FlashOffer',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = FlashOfferCreateActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    resetFilter () {
      this.filter = this.filter.map((item: {key: string}) => {
        return { ...item, value: '' }
      })
      this.action_type = FlashOfferCreateActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = FlashOfferCreateActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = FlashOfferCreateActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = FlashOfferCreateActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    setSelectedIds(ids: Array<string|number>) {
      this.selectedIds = ids
    },
    //DATA ACTION
    async fetchList(){
      return new Promise((resolve, reject) => {
        try{
          this.action_type = FlashOfferCreateActionTypes.FETCHING
          const sort = this.sortFilter
          const filter = {
            page: this.page,
            pageSize: this.pageSize,
            sort
          }

          const res = APIClient.get(AccountAPI.list, {
            params: filter
          })
          setTimeout(()=>{
            this.data = {
              list: [
                {id: 1, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'info', label: 'Đang hoạt động'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 2, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'warn', label: 'Sắp diễn ra'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 3, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 4, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 5, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 6, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 7, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},
                {id: 8, start_date: '2024-11-14 00:00:00', end_date: '2024-11-14 00:00:00', status: [{type: 'secondary', label: 'Đã kết thúc'}], title: 'Sự kiện Flash Offer tháng 5/2025', total: 5, reg_date: '2024-11-14 00:00:00', created_by: 'Admin'},

              ],
              totalRecords: 100,
              totalPage: 10
            }
            this.action_type = FlashOfferCreateActionTypes.FETCH_SUCCESS
            resolve(res)
          }, 300)
        } catch (e) {
          this.action_type = FlashOfferCreateActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    },

    async fetchRealEstateList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = FlashOfferCreateActionTypes.FETCHING
          const sort = this.sortFilter
          const pagination = {
            page: this.page,
            page_size: this.pageSize,
            sort: sort,
            use_flash_offer: true
          };

          const filter = buildFilterObject(this.filter, pagination);
          const res: any = await APIClient.get(FlashOfferAPI.flashoffer.real_estate, {
            params: filter
          })
          const { data } = res.data;
          console.log(289, data)
          this.data = {
            list: formatTableDataRealEstate(data.data) || [],
            totalRecords: data.total ?? 0,
            totalPage: data.last_page ?? 0
          }
          this.action_type = FlashOfferCreateActionTypes.FETCH_SUCCESS
          resolve(data);
        } catch (e) {
          this.action_type = FlashOfferCreateActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
